function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { __privateAdd, __privateGet, __privateSet, __privateWrapper } from "./chunk-PXG64RU4.js";

// src/queryClient.ts
import { functionalUpdate, hashKey, hashQueryKeyByOptions, noop, partialMatchKey, resolveStaleTime, skipToken } from "./utils.js";
import { QueryCache } from "./queryCache.js";
import { MutationCache } from "./mutationCache.js";
import { focusManager } from "./focusManager.js";
import { onlineManager } from "./onlineManager.js";
import { notifyManager } from "./notifyManager.js";
import { infiniteQueryBehavior } from "./infiniteQueryBehavior.js";
var _queryCache, _mutationCache, _defaultOptions, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline;
var QueryClient = /*#__PURE__*/function () {
  function QueryClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, QueryClient);
    __privateAdd(this, _queryCache);
    __privateAdd(this, _mutationCache);
    __privateAdd(this, _defaultOptions);
    __privateAdd(this, _queryDefaults);
    __privateAdd(this, _mutationDefaults);
    __privateAdd(this, _mountCount);
    __privateAdd(this, _unsubscribeFocus);
    __privateAdd(this, _unsubscribeOnline);
    __privateSet(this, _queryCache, config.queryCache || new QueryCache());
    __privateSet(this, _mutationCache, config.mutationCache || new MutationCache());
    __privateSet(this, _defaultOptions, config.defaultOptions || {});
    __privateSet(this, _queryDefaults, /* @__PURE__ */new Map());
    __privateSet(this, _mutationDefaults, /* @__PURE__ */new Map());
    __privateSet(this, _mountCount, 0);
  }
  return _createClass(QueryClient, [{
    key: "mount",
    value: function mount() {
      var _this = this;
      __privateWrapper(this, _mountCount)._++;
      if (__privateGet(this, _mountCount) !== 1) return;
      __privateSet(this, _unsubscribeFocus, focusManager.subscribe(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(focused) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!focused) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return _this.resumePausedMutations();
              case 1:
                __privateGet(_this, _queryCache).onFocus();
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()));
      __privateSet(this, _unsubscribeOnline, onlineManager.subscribe(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(online) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!online) {
                  _context2.n = 2;
                  break;
                }
                _context2.n = 1;
                return _this.resumePausedMutations();
              case 1:
                __privateGet(_this, _queryCache).onOnline();
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()));
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _a, _b;
      __privateWrapper(this, _mountCount)._--;
      if (__privateGet(this, _mountCount) !== 0) return;
      (_a = __privateGet(this, _unsubscribeFocus)) == null ? void 0 : _a.call(this);
      __privateSet(this, _unsubscribeFocus, void 0);
      (_b = __privateGet(this, _unsubscribeOnline)) == null ? void 0 : _b.call(this);
      __privateSet(this, _unsubscribeOnline, void 0);
    }
  }, {
    key: "isFetching",
    value: function isFetching(filters) {
      return __privateGet(this, _queryCache).findAll(_objectSpread(_objectSpread({}, filters), {}, {
        fetchStatus: "fetching"
      })).length;
    }
  }, {
    key: "isMutating",
    value: function isMutating(filters) {
      return __privateGet(this, _mutationCache).findAll(_objectSpread(_objectSpread({}, filters), {}, {
        status: "pending"
      })).length;
    }
    /**
     * Imperative (non-reactive) way to retrieve data for a QueryKey.
     * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
     *
     * Hint: Do not use this function inside a component, because it won't receive updates.
     * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
     */
  }, {
    key: "getQueryData",
    value: function getQueryData(queryKey) {
      var _a;
      var options = this.defaultQueryOptions({
        queryKey: queryKey
      });
      return (_a = __privateGet(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
  }, {
    key: "ensureQueryData",
    value: function ensureQueryData(options) {
      var defaultedOptions = this.defaultQueryOptions(options);
      var query = __privateGet(this, _queryCache).build(this, defaultedOptions);
      var cachedData = query.state.data;
      if (cachedData === void 0) {
        return this.fetchQuery(options);
      }
      if (options.revalidateIfStale && query.isStaleByTime(resolveStaleTime(defaultedOptions.staleTime, query))) {
        void this.prefetchQuery(defaultedOptions);
      }
      return Promise.resolve(cachedData);
    }
  }, {
    key: "getQueriesData",
    value: function getQueriesData(filters) {
      return __privateGet(this, _queryCache).findAll(filters).map(function (_ref3) {
        var queryKey = _ref3.queryKey,
          state = _ref3.state;
        var data = state.data;
        return [queryKey, data];
      });
    }
  }, {
    key: "setQueryData",
    value: function setQueryData(queryKey, updater, options) {
      var defaultedOptions = this.defaultQueryOptions({
        queryKey: queryKey
      });
      var query = __privateGet(this, _queryCache).get(defaultedOptions.queryHash);
      var prevData = query == null ? void 0 : query.state.data;
      var data = functionalUpdate(updater, prevData);
      if (data === void 0) {
        return void 0;
      }
      return __privateGet(this, _queryCache).build(this, defaultedOptions).setData(data, _objectSpread(_objectSpread({}, options), {}, {
        manual: true
      }));
    }
  }, {
    key: "setQueriesData",
    value: function setQueriesData(filters, updater, options) {
      var _this2 = this;
      return notifyManager.batch(function () {
        return __privateGet(_this2, _queryCache).findAll(filters).map(function (_ref4) {
          var queryKey = _ref4.queryKey;
          return [queryKey, _this2.setQueryData(queryKey, updater, options)];
        });
      });
    }
  }, {
    key: "getQueryState",
    value: function getQueryState(queryKey) {
      var _a;
      var options = this.defaultQueryOptions({
        queryKey: queryKey
      });
      return (_a = __privateGet(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
  }, {
    key: "removeQueries",
    value: function removeQueries(filters) {
      var queryCache = __privateGet(this, _queryCache);
      notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          queryCache.remove(query);
        });
      });
    }
  }, {
    key: "resetQueries",
    value: function resetQueries(filters, options) {
      var _this3 = this;
      var queryCache = __privateGet(this, _queryCache);
      return notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          query.reset();
        });
        return _this3.refetchQueries(_objectSpread({
          type: "active"
        }, filters), options);
      });
    }
  }, {
    key: "cancelQueries",
    value: function cancelQueries(filters) {
      var _this4 = this;
      var cancelOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaultedCancelOptions = _objectSpread({
        revert: true
      }, cancelOptions);
      var promises = notifyManager.batch(function () {
        return __privateGet(_this4, _queryCache).findAll(filters).map(function (query) {
          return query.cancel(defaultedCancelOptions);
        });
      });
      return Promise.all(promises).then(noop).catch(noop);
    }
  }, {
    key: "invalidateQueries",
    value: function invalidateQueries(filters) {
      var _this5 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return notifyManager.batch(function () {
        var _ref5, _ref6;
        __privateGet(_this5, _queryCache).findAll(filters).forEach(function (query) {
          query.invalidate();
        });
        if ((filters == null ? void 0 : filters.refetchType) === "none") {
          return Promise.resolve();
        }
        return _this5.refetchQueries(_objectSpread(_objectSpread({}, filters), {}, {
          type: (_ref5 = (_ref6 = filters == null ? void 0 : filters.refetchType) !== null && _ref6 !== void 0 ? _ref6 : filters == null ? void 0 : filters.type) !== null && _ref5 !== void 0 ? _ref5 : "active"
        }), options);
      });
    }
  }, {
    key: "refetchQueries",
    value: function refetchQueries(filters) {
      var _options$cancelRefetc,
        _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchOptions = _objectSpread(_objectSpread({}, options), {}, {
        cancelRefetch: (_options$cancelRefetc = options.cancelRefetch) !== null && _options$cancelRefetc !== void 0 ? _options$cancelRefetc : true
      });
      var promises = notifyManager.batch(function () {
        return __privateGet(_this6, _queryCache).findAll(filters).filter(function (query) {
          return !query.isDisabled() && !query.isStatic();
        }).map(function (query) {
          var promise = query.fetch(void 0, fetchOptions);
          if (!fetchOptions.throwOnError) {
            promise = promise.catch(noop);
          }
          return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
        });
      });
      return Promise.all(promises).then(noop);
    }
  }, {
    key: "fetchQuery",
    value: function fetchQuery(options) {
      var defaultedOptions = this.defaultQueryOptions(options);
      if (defaultedOptions.retry === void 0) {
        defaultedOptions.retry = false;
      }
      var query = __privateGet(this, _queryCache).build(this, defaultedOptions);
      return query.isStaleByTime(resolveStaleTime(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
  }, {
    key: "prefetchQuery",
    value: function prefetchQuery(options) {
      return this.fetchQuery(options).then(noop).catch(noop);
    }
  }, {
    key: "fetchInfiniteQuery",
    value: function fetchInfiniteQuery(options) {
      options.behavior = infiniteQueryBehavior(options.pages);
      return this.fetchQuery(options);
    }
  }, {
    key: "prefetchInfiniteQuery",
    value: function prefetchInfiniteQuery(options) {
      return this.fetchInfiniteQuery(options).then(noop).catch(noop);
    }
  }, {
    key: "ensureInfiniteQueryData",
    value: function ensureInfiniteQueryData(options) {
      options.behavior = infiniteQueryBehavior(options.pages);
      return this.ensureQueryData(options);
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      if (onlineManager.isOnline()) {
        return __privateGet(this, _mutationCache).resumePausedMutations();
      }
      return Promise.resolve();
    }
  }, {
    key: "getQueryCache",
    value: function getQueryCache() {
      return __privateGet(this, _queryCache);
    }
  }, {
    key: "getMutationCache",
    value: function getMutationCache() {
      return __privateGet(this, _mutationCache);
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return __privateGet(this, _defaultOptions);
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions(options) {
      __privateSet(this, _defaultOptions, options);
    }
  }, {
    key: "setQueryDefaults",
    value: function setQueryDefaults(queryKey, options) {
      __privateGet(this, _queryDefaults).set(hashKey(queryKey), {
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  }, {
    key: "getQueryDefaults",
    value: function getQueryDefaults(queryKey) {
      var defaults = _toConsumableArray(__privateGet(this, _queryDefaults).values());
      var result = {};
      defaults.forEach(function (queryDefault) {
        if (partialMatchKey(queryKey, queryDefault.queryKey)) {
          Object.assign(result, queryDefault.defaultOptions);
        }
      });
      return result;
    }
  }, {
    key: "setMutationDefaults",
    value: function setMutationDefaults(mutationKey, options) {
      __privateGet(this, _mutationDefaults).set(hashKey(mutationKey), {
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  }, {
    key: "getMutationDefaults",
    value: function getMutationDefaults(mutationKey) {
      var defaults = _toConsumableArray(__privateGet(this, _mutationDefaults).values());
      var result = {};
      defaults.forEach(function (queryDefault) {
        if (partialMatchKey(mutationKey, queryDefault.mutationKey)) {
          Object.assign(result, queryDefault.defaultOptions);
        }
      });
      return result;
    }
  }, {
    key: "defaultQueryOptions",
    value: function defaultQueryOptions(options) {
      if (options._defaulted) {
        return options;
      }
      var defaultedOptions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __privateGet(this, _defaultOptions).queries), this.getQueryDefaults(options.queryKey)), options), {}, {
        _defaulted: true
      });
      if (!defaultedOptions.queryHash) {
        defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
      }
      if (defaultedOptions.refetchOnReconnect === void 0) {
        defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
      }
      if (defaultedOptions.throwOnError === void 0) {
        defaultedOptions.throwOnError = !!defaultedOptions.suspense;
      }
      if (!defaultedOptions.networkMode && defaultedOptions.persister) {
        defaultedOptions.networkMode = "offlineFirst";
      }
      if (defaultedOptions.queryFn === skipToken) {
        defaultedOptions.enabled = false;
      }
      return defaultedOptions;
    }
  }, {
    key: "defaultMutationOptions",
    value: function defaultMutationOptions(options) {
      if (options == null ? void 0 : options._defaulted) {
        return options;
      }
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __privateGet(this, _defaultOptions).mutations), (options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey)), options), {}, {
        _defaulted: true
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      __privateGet(this, _queryCache).clear();
      __privateGet(this, _mutationCache).clear();
    }
  }]);
}();
_queryCache = new WeakMap();
_mutationCache = new WeakMap();
_defaultOptions = new WeakMap();
_queryDefaults = new WeakMap();
_mutationDefaults = new WeakMap();
_mountCount = new WeakMap();
_unsubscribeFocus = new WeakMap();
_unsubscribeOnline = new WeakMap();
export { QueryClient };